
	/**
	 * @description
	 *  Modelo del estado de una nota de CyR/NC.
	 *
	 * @see gigot-backend/Models/Orders/OrderEvent.cs
	 */

export enum OrderEventStatus {

	New = "New",
	ZonalManagerReceivedOldProducts = "ZonalManagerReceivedOldProducts",
	GigotReceivedOldProducts = "GigotReceivedOldProducts",
	GigotSendsInOrdersProducts = "GigotSendsInOrdersProducts",
	Resolved = "Resolved"
}

export const toOrderEventStatusString = function (orderEventStatus: OrderEventStatus): string {
	switch (orderEventStatus) {
		case OrderEventStatus.New:
			return "Nuevo";
		case OrderEventStatus.ZonalManagerReceivedOldProducts:
			return "Gerente zonal recibió los productos";
		case OrderEventStatus.GigotReceivedOldProducts:
			return "Gigot recibió los productos";
		case OrderEventStatus.GigotSendsInOrdersProducts:
			return "Gigot envió los productos";
		case OrderEventStatus.Resolved:
			return "Resuelto";
		default: {
			return "[Unknown OrderEventStatus]";
		}
	}
};
